import { Languages } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { applyLocale, LOCALES, type Locale } from '@/i18n';
import { supabase } from '@/lib/supabase';
import { Select } from '@farmos/ui/input';

export function LanguageSwitcher({ compact }: { compact?: boolean }) {
  const { t, i18n } = useTranslation();
  return (
    <label className="flex items-center gap-2 text-sm">
      <Languages className="size-4 shrink-0 text-muted" aria-hidden />
      <span className={compact ? 'sr-only' : ''}>{t('common.language')}</span>
      <Select
        className="min-h-9 w-auto py-0"
        value={i18n.language}
        onChange={(e) => {
          const l = e.target.value as Locale;
          applyLocale(l);
          // best effort: remember on the profile when signed in
          void supabase.rpc('set_my_locale', { p_locale: l });
        }}
      >
        {LOCALES.map((l) => (
          <option key={l.code} value={l.code}>
            {l.label}
          </option>
        ))}
      </Select>
    </label>
  );
}
